class TSCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerTrigger = document.querySelector("[data-js-cart]");
    this.isLoading = false;

    if (this.cartDrawerTrigger) {
      this.cartDrawerTrigger.addEventListener("click", () => {
        this.open();
      });
    }

    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        const item = e.target.closest("[data-line]");
        const line = item ? item.dataset.line : false;

        switch (e.target.dataset.trigger) {
          case "close":
            this.close();
            break;

          case "delete":
            if (this.isLoading) break;
            this.updateQuanity(line, 0);
            break;

          case "quantity":
            if (this.isLoading) break;
            let quantity = parseInt(item.querySelector('input[name="quantity"]').value);

            if (e.target.hasAttribute("data-plus")) {
              quantity += 1;
            } else if (e.target.hasAttribute("data-minus")) {
              quantity -= 1;
            }

            this.updateQuanity(line, quantity);
            break;
        }
      }
    });
  }

  updateQuanity(line, quantity) {
    this.toggleLoading();

    const data = {
      line: `${line}`,
      quantity: `${quantity}`,
      sections: ["ts-cart-drawer"],
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then((res) => res.json())
      .then((res) => {
        this.renderContent(res.sections);
      })
      .catch((err) => console.error('Cart update error:', err))
      .finally(() => this.toggleLoading());
  }

  async renderContent(sections) {
    const html = new DOMParser().parseFromString(sections['ts-cart-drawer'], "text/html");
    const selectors = [".ts-cart__wrapper"];

    selectors.forEach(selector => {
      const newEl = html.querySelector(selector);
      const currentEl = this.querySelector(selector);
      if (newEl && currentEl) {
        currentEl.innerHTML = newEl.innerHTML;
      }
    });

    initProductSlider();
    // removeProductsAlreadyInCart();
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("ts-cart", TSCartDrawer);

function initProductSlider() {
  const sliders = document.querySelectorAll('.product-slider');

  sliders.forEach((slider) => {
    const slides = slider.querySelectorAll('.swiper-slide');
    const navPrev = slider.closest('.product-slider-section')?.querySelector('.slider-prev');
    const navNext = slider.closest('.product-slider-section')?.querySelector('.slider-next');
    const singleSlideView = slides.length <= 1;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    const swiper = new Swiper(slider, {
      slidesPerView: singleSlideView ? 1 : 1.32,
      spaceBetween: 16,
      loop: false,
      slidesOffsetAfter: 20,
      allowTouchMove: !singleSlideView,
      navigation: singleSlideView ? {} : {
        nextEl: navNext,
        prevEl: navPrev,
      },
      pagination: {
        el: slider.closest('.product-slider-section')?.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    if (singleSlideView) {
      if (navPrev) navPrev.style.display = 'none';
      if (navNext) navNext.style.display = 'none';
    } else {
      if (navPrev) navPrev.style.display = '';
      if (navNext) navNext.style.display = '';
    }
  });
}

function removeProductFromSlider(variantId) {
  const productCard = document.querySelector(`.product-card [ts-quick-add="${variantId}"]`)?.closest('.swiper-slide');
  if (productCard) {
    const swiperInstance = productCard.closest('.swiper')?.swiper;
    if (swiperInstance) {
      const index = Array.from(productCard.parentNode.children).indexOf(productCard);
      swiperInstance.removeSlide(index);
      swiperInstance.update();
    }

    productCard.remove();
  }

  const remainingSlides = document.querySelectorAll('.product-slider .swiper-slide');
  const sliderSection = document.querySelector('.product-slider-section');

  if (sliderSection) {
    if (remainingSlides.length === 0) {
      sliderSection.remove();
    } else {
      initProductSlider();
    }
  }
}

function removeProductsAlreadyInCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartVariantIds = cart.items.map(item => item.variant_id);
      requestAnimationFrame(() => {
        cartVariantIds.forEach(id => removeProductFromSlider(id));
      });
    });
}

const wc_drawer_slider_pro_add_to_cart = async (button) => {
  const variantId = button.getAttribute('ts-quick-add');
  if (!variantId) return;

  await customElements.whenDefined('ts-cart');
  const cartDrawerEl = document.querySelector('ts-cart');
  if (!cartDrawerEl) return;

  cartDrawerEl.toggleLoading?.();

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then((res) => {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    })
    .then(() => fetch("/cart.js").then(res => res.json()))
    .then(() => fetch(`${window.location.pathname}?sections=ts-cart-drawer`))
    .then(res => res.json())
    .then((sections) => {
      if (typeof cartDrawerEl.renderContent === "function") {
        cartDrawerEl.renderContent(sections);
        removeProductFromSlider(variantId);
      }
      
      setTimeout(() => {
        cartDrawerEl.open?.();
        // initProductSlider();
      }, 50);
    })
    .catch((err) => console.error("Cart add failed:", err))
    .finally(() => cartDrawerEl.toggleLoading?.());
};

document.addEventListener("DOMContentLoaded", () => {
  initProductSlider();
  removeProductsAlreadyInCart();
});